import React, { createContext, useCallback, useContext, useLayoutEffect, useRef } from 'react';
import { iframeOnloadMetric } from './perf.config';
import { EMBEDDED_CONFLUENCE_METRICS_PREFIX, EMBEDDED_EDIT_CLICK, EMBEDDED_EDITOR_TTI, EMBEDDED_VIEW_TTI } from './constants';
export var PerformanceMetricsContext = /*#__PURE__*/createContext({
  stopIframeOnloadTimer: function stopIframeOnloadTimer() {}
});
var placeHolder = function placeHolder() {};

// PerformanceMetricsProvider is only applied to internal EP
// Methods provided by PerformanceMetricsContext are defined by default as () => {}
// This allows instances not wrapped in provider (ie embedded-confluence public) to opperate without errors
export var PerformanceMetricsProvider = function PerformanceMetricsProvider(_ref) {
  var children = _ref.children,
    contentType = _ref.contentType;
  var iframeOnloadTimer = useRef(iframeOnloadMetric());

  // init Embedded Confluence performance metrics
  useLayoutEffect(function () {
    // start Embedded Confluence iframe load metric
    iframeOnloadTimer.current.start();

    // Setup iframe post message handling
    var handler = function handler(e) {
      switch (e.data.type) {
        case EMBEDDED_CONFLUENCE_METRICS_PREFIX + EMBEDDED_VIEW_TTI:
          placeHolder();
          break;
        case EMBEDDED_CONFLUENCE_METRICS_PREFIX + EMBEDDED_EDITOR_TTI:
          placeHolder();
          break;
        case EMBEDDED_CONFLUENCE_METRICS_PREFIX + EMBEDDED_EDIT_CLICK:
          placeHolder();
      }
    };
    window.addEventListener('message', handler);
    return function () {
      window.removeEventListener('message', handler);
    };
  }, []);
  var stopIframeOnloadTimer = useCallback(function () {
    return iframeOnloadTimer.current.stop({
      customData: {
        contentType: contentType
      }
    });
  }, [contentType]);
  return /*#__PURE__*/React.createElement(PerformanceMetricsContext.Provider, {
    value: {
      stopIframeOnloadTimer: stopIframeOnloadTimer
    }
  }, children);
};
export var usePerformanceMetrics = function usePerformanceMetrics() {
  return useContext(PerformanceMetricsContext);
};